import React, { useState } from 'react';
import './App.css';

// 既存の18枚の画像をすべてインポート
import cowImage from './images/cow.png';
import dogImage from './images/dog.png';
import earImage from './images/ear.png';
import eyeImage from './images/eye.png';
import handImage from './images/hand.png';
import horseImage from './images/horse.png';
import houseImage from './images/house.png';
import footImage from './images/foot.png';
import moonImage from './images/moon.png';
import mountainImage from './images/mountain.png';
import mouthImage from './images/mouth.png';
import rainImage from './images/rain.png';
import riverImage from './images/river.png';
import stickImage from './images/stick.png';
import treeImage from './images/tree.png';
import waterImage from './images/water.png';
import birdImage from './images/bird.png';
import bookImage from './images/book.png';

// 竹、猫、菊など9枚の画像をインポート
import bambooImage from './images/bamboo.png';
import catImage from './images/cat.png';
import chrysanthemumImage from './images/chrysanthemum.png';
import fireImage from './images/fire.png';
import flowerImage from './images/flower.png';
import meatImage from './images/meat.png';
import peachImage from './images/peach.png';
import tongueImage from './images/tongue.png';
import toothImage from './images/tooth.png';

// 麦、酢、お茶など11枚の画像をインポート
import wheatImage from './images/wheat.png';
import vinegarImage from './images/vinegar.png';
import teaImage from './images/tea.png';
import swampImage from './images/swamp.png';
import stationImage from './images/station.png';
import boatImage from './images/boat.png';
import saltImage from './images/salt.png';
import chestnutImage from './images/chestnut.png';
import cicadaImage from './images/cicada.png';
import beansImage from './images/beans.png';
import sakeImage from './images/sake.png';

// 薬、柿、鼻など10枚の画像をインポート
import medicineImage from './images/medicine.png';
import persimmonImage from './images/persimmon.png';
import noseImage from './images/nose.png';
import windImage from './images/wind.png';
import orchidImage from './images/orchid.png';
import sixImage from './images/six.png';
import bowImage from './images/bow.png';
import apple2Image from './images/apple2.png';
import rubyImage from './images/ruby.png';
import carImage from './images/car.png';

// 動詞7枚の画像をインポート
import drinkImage from './images/drink.png';
import writeImage from './images/write.png';
import walkImage from './images/walk.png';
import sleepImage from './images/sleep.png';
import laughImage from './images/laugh.png';
import cryImage from './images/cry.png';
import hurtImage from './images/hurt.png';

// 家族・生活用品7枚の画像をインポート
import umbrellaImage from './images/umbrella.png';
import motherImage from './images/mother.png';
import shoeImage from './images/shoe.png';
import seaImage from './images/sea.png';
import sisterImage from './images/sister.png';
import fatherImage from './images/father.png';
import brotherImage from './images/brother.png';

// 最新追加8枚の画像をインポート
import strawberryImage from './images/strawberry.png';
import stomachImage from './images/stomach.png';
import radishImage from './images/radish.png';
import pigImage from './images/pig.png';
import mosquitoImage from './images/mosquito.png';
import elephantImage from './images/elephant.png';
import eggImage from './images/egg.png';
import carrotImage from './images/carrot.png';

// 新規追加7枚の画像をインポート
import soundImage from './images/sound.png';
import shellImage from './images/shell.png';
import riceImage from './images/rice.png';
import potatoImage from './images/potato.png';
import monkeyImage from './images/monkey.png';
import grassImage from './images/grass.png';
import fingerImage from './images/finger.png';

// 最新追加5枚の画像をインポート
import threadImage from './images/thread.png';
import upImage from './images/up.png';
import downImage from './images/down.png';
import rainbowImage from './images/rainbow.png';
import goldImage from './images/gold.png';

// 今回追加する6枚の画像をインポート
import rightImage from './images/right.png';
import leftImage from './images/left.png';
import springImage from './images/spring.png';
import summerImage from './images/summer.png';
import autumnImage from './images/autumn.png';
import winterImage from './images/winter.png';

const App = () => {
  const [currentCard, setCurrentCard] = useState(0);
  const [showHint, setShowHint] = useState(false);
  const [showAnswer, setShowAnswer] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('すべて');

  // 88枚の練習用カードデータ
  const allCards = [
    // 既存の18枚
    { id: 1, image: cowImage, word: 'うし', kanji: '牛', hint: 'う', category: '動物', type: '名詞' },
    { id: 2, image: dogImage, word: 'いぬ', kanji: '犬', hint: 'い', category: '動物', type: '名詞' },
    { id: 3, image: earImage, word: 'みみ', kanji: '耳', hint: 'み', category: 'からだ', type: '名詞' },
    { id: 4, image: eyeImage, word: 'め', kanji: '目', hint: 'め', category: 'からだ', type: '名詞' },
    { id: 5, image: handImage, word: 'て', kanji: '手', hint: 'て', category: 'からだ', type: '名詞' },
    { id: 6, image: horseImage, word: 'うま', kanji: '馬', hint: 'う', category: '動物', type: '名詞' },
    { id: 7, image: houseImage, word: 'いえ', kanji: '家', hint: 'い', category: '建物', type: '名詞' },
    { id: 8, image: footImage, word: 'あし', kanji: '足', hint: 'あ', category: 'からだ', type: '名詞' },
    { id: 9, image: moonImage, word: 'つき', kanji: '月', hint: 'つ', category: '自然', type: '名詞' },
    { id: 10, image: mountainImage, word: 'やま', kanji: '山', hint: 'や', category: '自然', type: '名詞' },
    { id: 11, image: mouthImage, word: 'くち', kanji: '口', hint: 'く', category: 'からだ', type: '名詞' },
    { id: 12, image: rainImage, word: 'あめ', kanji: '雨', hint: 'あ', category: '自然', type: '名詞' },
    { id: 13, image: riverImage, word: 'かわ', kanji: '川', hint: 'か', category: '自然', type: '名詞' },
    { id: 14, image: stickImage, word: 'つえ', kanji: '杖', hint: 'つ', category: '物', type: '名詞' },
    { id: 15, image: treeImage, word: 'き', kanji: '木', hint: 'き', category: '自然', type: '名詞' },
    { id: 16, image: waterImage, word: 'みず', kanji: '水', hint: 'み', category: '自然', type: '名詞' },
    { id: 17, image: birdImage, word: 'とり', kanji: '鳥', hint: 'と', category: '動物', type: '名詞' },
    { id: 18, image: bookImage, word: 'ほん', kanji: '本', hint: 'ほ', category: '物', type: '名詞' },
    
    // 竹、猫、菊など9枚
    { id: 19, image: bambooImage, word: 'たけ', kanji: '竹', hint: 'た', category: '自然', type: '名詞' },
    { id: 20, image: catImage, word: 'ねこ', kanji: '猫', hint: 'ね', category: '動物', type: '名詞' },
    { id: 21, image: chrysanthemumImage, word: 'きく', kanji: '菊', hint: 'き', category: '自然', type: '名詞' },
    { id: 22, image: fireImage, word: 'ひ', kanji: '火', hint: 'ひ', category: '自然', type: '名詞' },
    { id: 23, image: flowerImage, word: 'はな', kanji: '花', hint: 'は', category: '自然', type: '名詞' },
    { id: 24, image: meatImage, word: 'にく', kanji: '肉', hint: 'に', category: '食べ物', type: '名詞' },
    { id: 25, image: peachImage, word: 'もも', kanji: '桃', hint: 'も', category: '食べ物', type: '名詞' },
    { id: 26, image: tongueImage, word: 'した', kanji: '舌', hint: 'し', category: 'からだ', type: '名詞' },
    { id: 27, image: toothImage, word: 'は', kanji: '歯', hint: 'は', category: 'からだ', type: '名詞' },
    
    // 麦、酢、お茶など11枚
    { id: 28, image: wheatImage, word: 'むぎ', kanji: '麦', hint: 'む', category: '自然', type: '名詞' },
    { id: 29, image: vinegarImage, word: 'す', kanji: '酢', hint: 'す', category: '食べ物', type: '名詞' },
    { id: 30, image: teaImage, word: 'おちゃ', kanji: 'お茶', hint: 'お', category: '飲み物', type: '名詞' },
    { id: 31, image: swampImage, word: 'ぬま', kanji: '沼', hint: 'ぬ', category: '自然', type: '名詞' },
    { id: 32, image: stationImage, word: 'えき', kanji: '駅', hint: 'え', category: '建物', type: '名詞' },
    { id: 33, image: boatImage, word: 'ふね', kanji: '船', hint: 'ふ', category: '乗り物', type: '名詞' },
    { id: 34, image: saltImage, word: 'しお', kanji: '塩', hint: 'し', category: '食べ物', type: '名詞' },
    { id: 35, image: chestnutImage, word: 'くり', kanji: '栗', hint: 'く', category: '食べ物', type: '名詞' },
    { id: 36, image: cicadaImage, word: 'せみ', kanji: '蝉', hint: 'せ', category: '動物', type: '名詞' },
    { id: 37, image: beansImage, word: 'まめ', kanji: '豆', hint: 'ま', category: '食べ物', type: '名詞' },
    { id: 38, image: sakeImage, word: 'さけ', kanji: '酒', hint: 'さ', category: '飲み物', type: '名詞' },
    
    // 薬、柿、鼻など10枚
    { id: 39, image: medicineImage, word: 'くすり', kanji: '薬', hint: 'く', category: '物', type: '名詞' },
    { id: 40, image: persimmonImage, word: 'かき', kanji: '柿', hint: 'か', category: '食べ物', type: '名詞' },
    { id: 41, image: noseImage, word: 'はな', kanji: '鼻', hint: 'は', category: 'からだ', type: '名詞' },
    { id: 42, image: windImage, word: 'かぜ', kanji: '風', hint: 'か', category: '自然', type: '名詞' },
    { id: 43, image: orchidImage, word: 'らん', kanji: '蘭', hint: 'ら', category: '自然', type: '名詞' },
    { id: 44, image: sixImage, word: 'ろく', kanji: '六', hint: 'ろ', category: '数字', type: '名詞' },
    { id: 45, image: bowImage, word: 'れい', kanji: '礼', hint: 'れ', category: '物', type: '名詞' },
    { id: 46, image: apple2Image, word: 'りんご', kanji: '林檎', hint: 'り', category: '食べ物', type: '名詞' },
    { id: 47, image: rubyImage, word: 'ルビー', kanji: '紅玉', hint: 'る', category: '物', type: '名詞' },
    { id: 48, image: carImage, word: 'くるま', kanji: '車', hint: 'く', category: '乗り物', type: '名詞' },
    
    // 動詞7枚
    { id: 49, image: drinkImage, word: 'のむ', kanji: '飲む', hint: 'の', category: '動作', type: '動詞' },
    { id: 50, image: writeImage, word: 'かく', kanji: '書く', hint: 'か', category: '動作', type: '動詞' },
    { id: 51, image: walkImage, word: 'あるく', kanji: '歩く', hint: 'あ', category: '動作', type: '動詞' },
    { id: 52, image: sleepImage, word: 'ねる', kanji: '寝る', hint: 'ね', category: '動作', type: '動詞' },
    { id: 53, image: laughImage, word: 'わらう', kanji: '笑う', hint: 'わ', category: '感情', type: '動詞' },
    { id: 54, image: cryImage, word: 'なく', kanji: '泣く', hint: 'な', category: '感情', type: '動詞' },
    { id: 55, image: hurtImage, word: 'いたい', kanji: '痛い', hint: 'い', category: '感情', type: '形容詞' },
    
    // 家族・生活用品7枚
    { id: 56, image: umbrellaImage, word: 'かさ', kanji: '傘', hint: 'か', category: '物', type: '名詞' },
    { id: 57, image: motherImage, word: 'はは', kanji: '母', hint: 'は', category: '家族', type: '名詞' },
    { id: 58, image: shoeImage, word: 'くつ', kanji: '靴', hint: 'く', category: '物', type: '名詞' },
    { id: 59, image: seaImage, word: 'うみ', kanji: '海', hint: 'う', category: '自然', type: '名詞' },
    { id: 60, image: sisterImage, word: 'あね', kanji: '姉', hint: 'あ', category: '家族', type: '名詞' },
    { id: 61, image: fatherImage, word: 'ちち', kanji: '父', hint: 'ち', category: '家族', type: '名詞' },
    { id: 62, image: brotherImage, word: 'あに', kanji: '兄', hint: 'あ', category: '家族', type: '名詞' },
    
    // 最新追加8枚
    { id: 63, image: strawberryImage, word: 'いちご', kanji: '苺', hint: 'い', category: '食べ物', type: '名詞' },
    { id: 64, image: stomachImage, word: 'い', kanji: '胃', hint: 'い', category: 'からだ', type: '名詞' },
    { id: 65, image: radishImage, word: 'だいこん', kanji: '大根', hint: 'だ', category: '食べ物', type: '名詞' },
    { id: 66, image: pigImage, word: 'ぶた', kanji: '豚', hint: 'ぶ', category: '動物', type: '名詞' },
    { id: 67, image: mosquitoImage, word: 'か', kanji: '蚊', hint: 'か', category: '動物', type: '名詞' },
    { id: 68, image: elephantImage, word: 'ぞう', kanji: '象', hint: 'ぞ', category: '動物', type: '名詞' },
    { id: 69, image: eggImage, word: 'たまご', kanji: '卵', hint: 'た', category: '食べ物', type: '名詞' },
    { id: 70, image: carrotImage, word: 'にんじん', kanji: '人参', hint: 'に', category: '食べ物', type: '名詞' },
    
    // 新規追加7枚
    { id: 71, image: soundImage, word: 'おと', kanji: '音', hint: 'お', category: '物', type: '名詞' },
    { id: 72, image: shellImage, word: 'かい', kanji: '貝', hint: 'か', category: '動物', type: '名詞' },
    { id: 73, image: riceImage, word: 'こめ', kanji: '米', hint: 'こ', category: '食べ物', type: '名詞' },
    { id: 74, image: potatoImage, word: 'いも', kanji: '芋', hint: 'い', category: '食べ物', type: '名詞' },
    { id: 75, image: monkeyImage, word: 'さる', kanji: '猿', hint: 'さ', category: '動物', type: '名詞' },
    { id: 76, image: grassImage, word: 'くさ', kanji: '草', hint: 'く', category: '自然', type: '名詞' },
    { id: 77, image: fingerImage, word: 'ゆび', kanji: '指', hint: 'ゆ', category: 'からだ', type: '名詞' },
    
    // 最新追加5枚
    { id: 78, image: threadImage, word: 'いと', kanji: '糸', hint: 'い', category: '物', type: '名詞' },
    { id: 79, image: upImage, word: 'うえ', kanji: '上', hint: 'う', category: '物', type: '名詞' },
    { id: 80, image: downImage, word: 'した', kanji: '下', hint: 'し', category: '物', type: '名詞' },
    { id: 81, image: rainbowImage, word: 'にじ', kanji: '虹', hint: 'に', category: '自然', type: '名詞' },
    { id: 82, image: goldImage, word: 'きん', kanji: '金', hint: 'き', category: '物', type: '名詞' },
    
    // 今回追加する6枚
    { id: 83, image: rightImage, word: 'みぎ', kanji: '右', hint: 'み', category: '物', type: '名詞' },
    { id: 84, image: leftImage, word: 'ひだり', kanji: '左', hint: 'ひ', category: '物', type: '名詞' },
    { id: 85, image: springImage, word: 'はる', kanji: '春', hint: 'は', category: '季節', type: '名詞' },
    { id: 86, image: summerImage, word: 'なつ', kanji: '夏', hint: 'な', category: '季節', type: '名詞' },
    { id: 87, image: autumnImage, word: 'あき', kanji: '秋', hint: 'あ', category: '季節', type: '名詞' },
    { id: 88, image: winterImage, word: 'ふゆ', kanji: '冬', hint: 'ふ', category: '季節', type: '名詞' }
  ];

  // カテゴリーでフィルタリング
  const cards = selectedCategory === 'すべて' 
    ? allCards 
    : selectedCategory === '名詞'
    ? allCards.filter(card => card.type === '名詞')
    : selectedCategory === '動詞'
    ? allCards.filter(card => card.type === '動詞' || card.type === '形容詞')
    : allCards.filter(card => card.category === selectedCategory);

  const currentCardData = cards[currentCard] || allCards[0];

  // カテゴリー変更時にカードをリセット
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setCurrentCard(0);
    resetCard();
  };

  // 音声再生機能
  const speakWord = (text) => {
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = 'ja-JP';
      utterance.rate = 0.8;
      speechSynthesis.speak(utterance);
    }
  };

  // 次のカードへ
  const nextCard = () => {
    setCurrentCard((prev) => (prev + 1) % cards.length);
    resetCard();
  };

  // 前のカードへ
  const prevCard = () => {
    setCurrentCard((prev) => (prev - 1 + cards.length) % cards.length);
    resetCard();
  };

  // カードをリセット
  const resetCard = () => {
    setShowHint(false);
    setShowAnswer(false);
  };

  // ヒントを表示
  const showHintHandler = () => {
    setShowHint(true);
    // 語頭音を音声で再生
    speakWord(currentCardData.hint);
  };

  // 答えを表示
  const showAnswerHandler = () => {
    setShowAnswer(true);
    speakWord(currentCardData.word);
  };

  return (
    <div className="app">
      <div className="container">
        {/* ヘッダー */}
        <div className="header">
          <h1>呼称練習</h1>
          <div className="header-info">
            <span>{currentCardData.category}</span>
            <span>
              {currentCard + 1} / {cards.length}
            </span>
          </div>
        </div>

        {/* カテゴリー選択 */}
        <div className="category-selector">
          <select 
            value={selectedCategory} 
            onChange={(e) => handleCategoryChange(e.target.value)}
            className="category-select"
          >
            <option value="すべて">すべて ({allCards.length}枚)</option>
            <option value="名詞">名詞 ({allCards.filter(card => card.type === '名詞').length}枚)</option>
            <option value="動詞">動詞・形容詞 ({allCards.filter(card => card.type === '動詞' || card.type === '形容詞').length}枚)</option>
            <option value="からだ">からだ ({allCards.filter(card => card.category === 'からだ').length}枚)</option>
            <option value="動物">動物 ({allCards.filter(card => card.category === '動物').length}枚)</option>
            <option value="自然">自然 ({allCards.filter(card => card.category === '自然').length}枚)</option>
            <option value="食べ物">食べ物 ({allCards.filter(card => card.category === '食べ物').length}枚)</option>
            <option value="家族">家族 ({allCards.filter(card => card.category === '家族').length}枚)</option>
            <option value="季節">季節 ({allCards.filter(card => card.category === '季節').length}枚)</option>
            <option value="動作">動作 ({allCards.filter(card => card.category === '動作').length}枚)</option>
            <option value="感情">感情 ({allCards.filter(card => card.category === '感情').length}枚)</option>
          </select>
        </div>

        {/* 問題番号 */}
        <div className="problem-number">
          <h2>第{currentCard + 1}問</h2>
          <div className="word-type">{currentCardData.type}</div>
        </div>

        {/* 絵カード */}
        <div className="card-section">
          <div className="card-image">
            <img 
              src={currentCardData.image} 
              alt={currentCardData.word}
              className="custom-image"
            />
          </div>
          
          {/* 進捗バー */}
          <div className="progress-bar">
            <div 
              className="progress-fill"
              style={{ width: `${((currentCard + 1) / cards.length) * 100}%` }}
            ></div>
          </div>
        </div>

        {/* ボタン群 */}
        <div className="buttons-section">
          {/* ヒントボタン */}
          <button onClick={showHintHandler} className="hint-button">
            ヒント
          </button>

          {/* ヒント表示 */}
          {showHint && (
            <div className="hint-display">
              <div className="hint-label">語頭音</div>
              <button
                onClick={() => speakWord(currentCardData.hint)}
                className="hint-speak-button"
              >
                🔊 「{currentCardData.hint}」
              </button>
            </div>
          )}

          {/* 答えボタン */}
          <button onClick={showAnswerHandler} className="answer-button">
            答え
          </button>

          {/* 答え表示 */}
          {showAnswer && (
            <div className="answer-display">
              <button
                onClick={() => speakWord(currentCardData.word)}
                className="speak-button"
              >
                🔊 「{currentCardData.word}」
              </button>
              <div className="answer-kanji">
                {currentCardData.kanji}
              </div>
            </div>
          )}
        </div>

        {/* ナビゲーション */}
        <div className="navigation">
          <button onClick={prevCard} className="nav-button">
            ← 前へ
          </button>
          
          <button onClick={resetCard} className="reset-button">
            🔄 リセット
          </button>
          
          <button onClick={nextCard} className="nav-button">
            次へ →
          </button>
        </div>

        {/* フッター */}
        <div className="footer">
          <p>呼称練習アプリ</p>
        </div>
      </div>
    </div>
  );
};

export default App;